import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class CryptService {

    public key = CryptoJS.enc.Utf8.parse('13313586896631234900207000800912');
    public iv = CryptoJS.enc.Utf8.parse('6896631234900212');
    constructor() { }


    public Encrypt(value : string)
    {
        var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value), this.key,
        {
            keySize: 128 / 8,
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
            }).toString();
        //var cipher = CryptoJS.createCipheriv('aes256',this.key,this.iv)
        //var crypted = cipher.update(value, 'utf8', 'base64')
        //crypted += cipher.final('base64');
        return encrypted;
    }
    public Decrypt(valueEcrypted: string) {
        var decrypted = CryptoJS.AES.decrypt(valueEcrypted, this.key, {
            keySize: 128 / 8,
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return decrypted;
    }
}
